import devices from "current-device";
export const device_name = () => devices.desktop() ? "desktop_web" : "mobile_web";
